import React, {Component, Fragment} from 'react';
import Helmet from 'react-helmet';
import {Link} from 'react-router-dom';
import PropTypes from 'prop-types';
import socket from '../../helpers/socket';
import ptiqcsLogo from '../../assets/images/logos/ptiqcs-logo.png';
import ptiqcsLogoSymbol from '../../assets/images/logos/ptiqcs-logo-symbol.png';
import crisLogoSymbol from '../../assets/images/logos/cris-logo-50.png';
import CreateAndonFormModal from "./CreateAndonFormModal";
import ChatModal from "./ChatModal";

class Header extends Component {
	constructor(props) {
		super(props);

		this.languages = [
			{
				key: 'en',
				value: 'English'
			},
			{
				key: 'es',
				value: 'Spanish'
			}
		];

		this.state = {
			showAndonModal: false,
			showChatModal: false
		}
	}

	_logoutAction = (e) => {
		e.preventDefault();
		const {logoutAction, session} = this.props;

		if(session) {
			socket().emit('user.leave.personal', session.user_id);
			socket().emit('role.leave', session.active_role_id);
		}
		logoutAction();
	};

	_switchLanguageAction = (locale) => (e) => {
		e.preventDefault();
		const {switchLanguageAction} = this.props;
		switchLanguageAction(locale);
	};

	openAndonModal = () => this.setState({ showAndonModal: true });
	closeAndonModal = () => this.setState({ showAndonModal: false });

	openChatModal = () => this.setState({ showChatModal: true });
	closeChatModal = () => this.setState({ showChatModal: false });

	render() {
		const {translate, activeLocale, session} = this.props;
		const selectedLanguage = this.languages.find(item => item.key === activeLocale);
		const { user } = session;

		return (
			<Fragment>
				<header className="main-header">
					<Link to="/dashboard" className="logo" style={{background: "#000000"}}>
						<span className="logo-mini">
							<img src={ptiqcsLogoSymbol} alt="PTIQCS" height="50"/>
						</span>
						<span className="logo-lg">
							<img src={ptiqcsLogo} alt="PTIQCS" height="50"/>
						</span>
					</Link>

					<nav className="navbar navbar-static-top">
						{/*eslint-disable-next-line jsx-a11y/anchor-is-valid*/}
						<a href="" className="sidebar-toggle" data-toggle="push-menu" role="button">
							<span className="sr-only">{ translate('header.menu') }</span>
							<span className="icon-bar"/>
							<span className="icon-bar"/>
							<span className="icon-bar"/>
							<span className="sidebar-toggle-text hidden-sm hidden-xs">{ translate('header.menu') }</span>
						</a>

						<div className="logo pull-left" style={{width: "auto"}}>
							<img src={crisLogoSymbol} alt="PTIQCS" height="44%"/>
						</div>

						<div className="navbar-custom-menu">
							<ul className="nav navbar-nav">
								<li>
									<button className="btn btn-success" onClick={this.openChatModal}
									        style={{margin: '8px 5px 0 0', borderRadius: '3px', 'padding': '6px 12px 6px 12px'}}
									>
										<i className="fa fa-commenting"/>
									</button>
								</li>
								<li>
									<button className="btn btn-danger" onClick={this.openAndonModal}
											style={{margin: '8px 0 0 0', borderRadius: '3px', 'padding': '6px 12px 6px 12px'}}
									>
										<i className="fa fa-warning"/>
									</button>
								</li>
								<li className="dropdown">
									{/*eslint-disable-next-line jsx-a11y/anchor-is-valid*/}
									<a href="" className="dropdown-toggle" data-toggle="dropdown">
										<i className="fa fa-globe" aria-hidden="true"/>
										<span className="nav-item-text hidden-sm hidden-xs">
										{ translate('header.language', {language: selectedLanguage.value}) }
									</span>
									</a>
									<ul className="dropdown-menu">
										{
											this.languages.map((lang) => {
												return (
													<li key={`header_lang_${lang.key}`}>
														{/*eslint-disable-next-line jsx-a11y/anchor-is-valid*/}
														<a href="" onClick={this._switchLanguageAction(lang.key)}>
															{ translate('common.text', {text: lang.value}) }
														</a>
													</li>
												)
											})
										}
									</ul>
								</li>

								<li>
									<Link to="/profile">
										<i className="fa fa-user" aria-hidden="true"/>
										<span className="nav-item-text hidden-sm hidden-xs">
										{user.email}
									</span>
									</Link>
								</li>

								<li>
									<Link to="/auth/logout" onClick={this._logoutAction}>
										<i className="fa fa-sign-out" aria-hidden="true"/>
										<span className="nav-item-text hidden-sm hidden-xs">
										{ translate('header.logout') }
									</span>
									</Link>
								</li>
							</ul>
						</div>
					</nav>
				</header>
				<CreateAndonFormModal show={this.state.showAndonModal} closeAction={this.closeAndonModal}/>
				<ChatModal show={this.state.showChatModal} closeAction={this.closeChatModal}/>
				<Helmet script={[{
					'type': 'text/javascript',
					'innerHTML': '$(".sidebar-toggle").pushMenu();'
				}]}/>
			</Fragment>
		)
	}
}

Header.propTypes = {
	activeLocale: PropTypes.string.isRequired,
	session: PropTypes.object.isRequired,
	translate: PropTypes.func.isRequired,
	logoutAction: PropTypes.func.isRequired,
	switchLanguageAction: PropTypes.func.isRequired
};

export default Header
